const ProductModel = {
    initModel: {
        id: null,
        groupId: -1,
        title: '',
        proteins: 0,
        fat: 0,
        carbohydrates: 0,
        energyValueKcal: 0,
        water: 0,
        dryMaterial: 0,
        vegetableProtein: 0,
        mineralSubstances: 0,
        sodium: 0,
        magnesium: 0,
        phosphorus: 0,
        potassium: 0,
        calcium: 0,
        iodine: 0,
        vitaminB2: 0,
        niacinVitaminPP: 0,
        niacinEquivalent: 0,
        vitaminB6: 0,
        alcohol: 0,
        energyKj: 0,
        iron: 0,
        vitaminB1: 0,
        zinc: 0,
        saturatedFattyAcids: 0,
        monounsaturatedFattyAcids: 0,
        polyunsaturatedFattyAcids: 0,
        starch: 0,
        fiberMaterials: 0,
        selenium: 0,
        vitaminARetinol: 0,
        vitaminETocopherol: 0,
        folicAcid: 0,
        vitaminC: 0,
        animalProtein: 0,
        cholesterol: 0,
        vitaminD: 0,
        vitaminB12: 0,
        sugar: 0,
    },
    fieldNames: [
        'groupId',
        'title',
        'proteins',
        'fat',
        'carbohydrates',
        'energyValueKcal',
        'water',
        'dryMaterial',
        'vegetableProtein',
        'mineralSubstances',
        'sodium',
        'magnesium',
        'phosphorus',
        'potassium',
        'calcium',
        'iodine',
        'vitaminB2',
        'niacinVitaminPP',
        'niacinEquivalent',
        'vitaminB6',
        'alcohol',
        'energyKj',
        'iron',
        'vitaminB1',
        'zinc',
        'saturatedFattyAcids',
        'monounsaturatedFattyAcids',
        'polyunsaturatedFattyAcids',
        'starch',
        'fiberMaterials',
        'selenium',
        'vitaminARetinol',
        'vitaminETocopherol',
        'folicAcid',
        'vitaminC',
        'animalProtein',
        'cholesterol',
        'vitaminD',
        'vitaminB12',
        'sugar',
    ],
    fieldsTypes: [
        'select',
        'text',
        'number',
        'number',
        'number',
        'number',
        'number',
        'number',
        'number',
        'number',
        'number',
        'number',
        'number',
        'number',
        'number',
        'number',
        'number',
        'number',
        'number',
        'number',
        'number',
        'number',
        'number',
        'number',
        'number',
        'number',
        'number',
        'number',
        'number',
        'number',
        'number',
        'number',
        'number',
        'number',
        'number',
        'number',
        'number',
        'number',
        'number',
        'number',
    ],
};

export default ProductModel;
